import { api } from "./api";

export type AdminUser = {
  id: string;
  email: string;
  name: string;
  role: "ADMIN" | "SUPERADMIN";
};

export async function login(email: string, password: string) {
  const res = await api<{ token: string; user: AdminUser }>(
    "/api/admin/auth/login",
    { method: "POST", body: JSON.stringify({ email, password }) }
  );
  localStorage.setItem("admin_token", res.token);
  return res.user;
}

export async function logout() {
  try {
    await api("/api/admin/auth/logout", { method: "POST" });
  } finally {
    localStorage.removeItem("admin_token");
  }
}

export async function me(): Promise<AdminUser | null> {
  try {
    const res = await api<{ user: AdminUser }>("/api/admin/auth/me");
    return res.user;
  } catch {
    return null;
  }
}
